const inspectionFields = [
    {
        id: 1,
        section: 'inspection',
        field: 'Inspection name',
        field_key: 'inspection_name',
        desc: 'Name of the inspection',
        type: 'dropdown',
    },
    {
        id: 2,
        section: 'inspection',
        field: 'Inspection Type',
        field_key: 'inspection_type',
        desc: 'Type of the inspection',
        type: 'dropdown',
    },
    {
        id: 3,
        section: 'inspection',
        field: 'Start date',
        field_key: 'start_date',
        desc: 'Start date of the inspection',
        type: 'dropdown',
    },
    {
        id: 4,
        section: 'inspection',
        field: 'End date',
        field_key: 'end_date',
        desc: 'End date of the inspection',
        type: 'dropdown',
    },
    {
        id: 5,
        section: 'inspection',
        field: 'Term',
        field_key: 'term',
        desc: 'Term of the inspection',
        type: 'dropdown',
    },
    // {
    //     id: 1,
    //     section: 'inspection',
    //     field: 'Status',
    //     field_key: 'inspection_name',
    //     desc: 'Nam eof the inspection',
    //     type: 'text_area',
    // },
]

export default inspectionFields;